import React, { useMemo, useState } from 'react';
import ContactForm from '../components/ContactForm';
import PageHero from '../components/PageHero';

const ContactPage = ({ siteContent }) => {
  const [activeForm, setActiveForm] = useState('contact');
  const salesModal = siteContent?.salesModal;

  const contactConfig = useMemo(
    () => ({
      ...salesModal,
      title: 'Contact Form',
      description: 'Share your query and our team will route it to the right owner.',
      source: 'contact',
      submitButton: {
        ...(salesModal?.submitButton || {}),
        idleLabel: 'Send Contact Request'
      }
    }),
    [salesModal]
  );

  const activeConfig = activeForm === 'sales' ? salesModal : contactConfig;

  return (
    <div className="flex flex-col w-full bg-white pt-24">
      <PageHero
        eyebrow="Get in touch"
        title="Talk to the team."
        description="Whether it's a deep technical question, a partnership idea, or a sales inquiry — start here."
        coverImage="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2000&auto=format&fit=crop"
        coverVideo="https://videos.pexels.com/video-files/3246669/3246669-sd_640_360_25fps.mp4"
      />
      <div className="mx-auto mt-8 flex w-full max-w-3xl gap-3 px-6">
        <button
          type="button"
          onClick={() => setActiveForm('contact')}
          className={`rounded-full px-5 py-2 text-xs font-semibold uppercase tracking-[0.14em] transition-colors ${
            activeForm === 'contact'
              ? 'bg-[#1a1a1a] text-white'
              : 'border border-gray-300 text-[#1a1a1a] hover:border-[#1a1a1a]'
          }`}
        >
          Contact Form
        </button>
        <button
          type="button"
          onClick={() => setActiveForm('sales')}
          className={`rounded-full px-5 py-2 text-xs font-semibold uppercase tracking-[0.14em] transition-colors ${
            activeForm === 'sales'
              ? 'bg-[#1a1a1a] text-white'
              : 'border border-gray-300 text-[#1a1a1a] hover:border-[#1a1a1a]'
          }`}
        >
          Sales
        </button>
      </div>
      <div className="mx-auto mt-8 w-full max-w-3xl px-6">
        <div className="flex flex-col items-start gap-5 rounded-[24px] border border-[#e5e5e5] bg-[#f4f4f4] p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#1a1a1a]/60">Prefer talking?</p>
            <h3 className="mt-1 text-xl font-semibold text-[#1a1a1a]">Call our AI agent</h3>
            <p className="mt-1 max-w-md text-sm text-[#1a1a1a]/70">
              Instant voice support in your browser — book appointments, hear about products, or reach a human specialist. Free, no app.
            </p>
          </div>
          <a
            href="/call"
            target="_blank"
            rel="noopener"
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-[#1a1a1a] px-6 py-3 text-xs font-semibold uppercase tracking-[0.14em] text-white transition-colors hover:bg-black"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            Start voice call
          </a>
        </div>
      </div>
      <ContactForm salesModal={activeConfig} />
    </div>
  );
};

export default ContactPage;
